import { Box } from '@mui/material';
import { WorkflowStepType } from '@bandido/shared/constants';

import WorkflowStep from '@frontend/assets/workflowStep';
import ArrowLeft from '@frontend/assets/arrowLeft';

import { containerStyles, contentWrapperStyles, spacerStyles, rotatedArrowStyles } from './styles';

import { handleDragStart } from './utils';

export interface WorkflowStepTypeButtonProps {
  variant: WorkflowStepType;
  disabled?: boolean;
}

const WorkflowStepTypeButton = ({ variant, disabled }: WorkflowStepTypeButtonProps) => {
  const showLeftArrow = variant === WorkflowStepType.FINAL || variant === WorkflowStepType.CUSTOM;
  const showRightArrow = variant === WorkflowStepType.INITIAL || variant === WorkflowStepType.CUSTOM;

  return (
    <Box draggable onDragStart={(event) => handleDragStart(event, variant)} sx={containerStyles(disabled)}>
      {showLeftArrow ? <ArrowLeft className="step-handle" /> : <div style={spacerStyles} />}

      <Box className="step-content-wrapper" sx={contentWrapperStyles(disabled)}>
        <WorkflowStep className="step-content" />
      </Box>

      {showRightArrow ? <ArrowLeft className="step-handle" style={rotatedArrowStyles} /> : <div style={spacerStyles} />}
    </Box>
  );
};

export default WorkflowStepTypeButton;
